import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./DateFilter.scss";
import CalendarIcon from "./../icons/calendar.svg";

const DateFilter = ({ startDate, handleDateFilterChange }) => {
  const CustomButton = React.forwardRef(({ value, onClick }, ref) => (
    <button className="customInput" onClick={onClick} ref={ref}>
      {value ? value : "Select Date"}
      <img src={CalendarIcon} alt="Calendar icon" className="calendarIcon" />
    </button>
  ));

  return (
    <DatePicker
      showIcon
      selected={startDate}
      onChange={handleDateFilterChange}
      startDate={startDate}
      dateFormat="dd/MM/yyyy"
      wrapperClassName="datePicker"
      icon={
        <img src={CalendarIcon} alt="Calendar icon" className="calendarIcon" />
      }
      isClearable
      customInput={<CustomButton />}
      maxDate={new Date()}
    />
  );
};

export default DateFilter;
